function o(o,t){let e=document.querySelector(`[data-toc="${o}"]`);const n=e?.getBoundingClientRect().top,c=n&&n+window.scrollY-20;window.scrollTo({top:c,behavior:"smooth"})}export{o as scrollHandler};
//# sourceMappingURL=scrollHandler.js.map
